import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { mergeMap, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { PresenceReportService } from '~/repositories/presence-report/services/presence-report.service';
import * as PresenceReportActions from '~/repositories/presence-report/store/presence-report.actions';

@Injectable()
export class PresenceReportEffects {
  fetchOrgans$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PresenceReportActions.fetchOrgans),
      mergeMap(() => {
        return this.presenceReportService.fetchAllOrgans().pipe(
          map((organs) => PresenceReportActions.fetchOrgansSuccess({ organs })),
          catchError((error) => of(PresenceReportActions.fetchOrgansFailure({ error })))
        );
      })
    )
  );
  publishPresenceReportDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PresenceReportActions.publishPresenceReportDetails),
      mergeMap((entity) => {
        return this.presenceReportService.publishPresenceReportDetails(entity.presenceReportRequestEntity).pipe(
          map(() => PresenceReportActions.publishPresenceReportDetailsSuccess()),
          catchError((error) => of(PresenceReportActions.fetchOrgansFailure({ error })))
        );
      })
    )
  );
  // collection of all failures that have to show a toast message
  failures$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          ...[PresenceReportActions.fetchOrgansFailure, PresenceReportActions.publishPresenceReportDetailsFailure]
        ),
        tap(({ error }) => {
          this.messageService.add({
            severity: 'error',
            detail: this.translateService.instant('presence.report.error'),
            life: 3000
          });
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private presenceReportService: PresenceReportService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {}
}
